import { getLabelMessage } from '@gef-ui/localization/messages';

import { isDateWithOrder, isFullySpecifiedDate } from 'app/forms/validations/common';
import isAnnualDayMonthsOrder from 'app/forms/validations/isAnnualDayMonthsOrder';
import isBusinessIn from 'app/forms/validations/isBusinessIn';
import isBusinessName from 'app/forms/validations/isBusinessName';
import isCarRegNo from 'app/forms/validations/isCarRegNo';
import isFirstName from 'app/forms/validations/isFirstName';
import isMunicipality from 'app/forms/validations/isMunicipality';
import isNumber from 'app/forms/validations/isNumber';
import isPolicyFrameworkNo from 'app/forms/validations/isPolicyFrameworkNo';
import isPolicyNo from 'app/forms/validations/isPolicyNo';
import isSurname from 'app/forms/validations/isSurname';
import isYearOrder from 'app/forms/validations/isYearOrder';
import isZipCode from 'app/forms/validations/isZipCode';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const POLICY_OVERVIEW_FILTER_FORM_NAME = 'policyOverview-filter';

const {
	firstName,
	surname,
	businessName,
	businessIn,
	municipality,
	zipCode,
	policyNumber,
	product,
	birthYearFrom,
	birthYearTo,
	productDomain,
} = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	firstName,
	surname,
	businessName,
	businessIn,
	municipality,
	zipCode,
	semaphore: 'semaphore',
	policyNumber,
	rsNumber: 'rsNumber',
	policyStatus: 'policyStatus',
	productDomain,
	product,
	policyPaymentStatus: 'policyPaymentStatus',
	policyHolderNumber: 'policyHolderNumber',
	sellerLogin: 'sellerLogin',

	policyValueDateFrom: 'policyValueDateFrom',
	policyValueDateTo: 'policyValueDateTo',

	policyOpenDateFrom: 'policyOpenDateFrom',
	policyOpenDateTo: 'policyOpenDateTo',

	policyFinalDateFrom: 'policyFinalDateFrom',
	policyFinalDateTo: 'policyFinalDateTo',

	policyValueDateAnnualFrom: 'policyValueDateAnnualFrom',
	policyValueDateAnnualTo: 'policyValueDateAnnualTo',

	policyOpenDateAnnualFrom: 'policyOpenDateAnnualFrom',
	policyOpenDateAnnualTo: 'policyOpenDateAnnualTo',

	valueDateAnnualFrom: 'valueDateAnnualFrom',
	valueDateAnnualTo: 'valueDateAnnualTo',

	policyHolderAnnualBirthDateFrom: 'policyHolderAnnualBirthDateFrom',
	policyHolderAnnualBirthDateTo: 'policyHolderAnnualBirthDateTo',

	birthYearFrom,
	birthYearTo,

	gcpContractsOnly: 'gcpContractsOnly',
	gpContractsOnly: 'gpContractsOnly',
	frameworkPolicyOnly: 'frameworkPolicyOnly',
	activePolicyWoQuotationOnly: 'activePolicyWoQuotationOnly',
	withSubordinates: 'withSubordinates',

	subordinateFirstName: 'subordinateFirstName',
	subordinateSurname: 'subordinateSurname',
	subordinateBusinessName: 'subordinateBusinessName',
	carRegNo: 'carRegNo',
};

export default () => ({
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [isFirstName()],
	},
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [isSurname()],
	},
	[FIELDS.businessName]: {
		deepPath: [FIELDS.businessName],
		validations: [isBusinessName()],
	},
	[FIELDS.businessIn]: {
		deepPath: [FIELDS.businessIn],
		validations: [isBusinessIn()],
	},
	[FIELDS.municipality]: {
		deepPath: [FIELDS.municipality],
		validations: [isMunicipality()],
	},
	[FIELDS.zipCode]: {
		deepPath: [FIELDS.zipCode],
		validations: [isZipCode()],
	},
	[FIELDS.semaphore]: {
		deepPath: [FIELDS.semaphore],
		validations: [],
	},
	[FIELDS.policyHolderAnnualBirthDateFrom]: {
		deepPath: [FIELDS.policyHolderAnnualBirthDateFrom],
		dependentFields: [FIELDS.policyHolderAnnualBirthDateTo],
		validations: [
			isAnnualDayMonthsOrder({
				fromFieldName: FIELDS.policyHolderAnnualBirthDateFrom,
				toFieldName: FIELDS.policyHolderAnnualBirthDateTo,
			}),
		],
	},
	[FIELDS.policyHolderAnnualBirthDateTo]: {
		deepPath: [FIELDS.policyHolderAnnualBirthDateTo],
		dependentFields: [FIELDS.policyHolderAnnualBirthDateFrom],
		validations: [
			isAnnualDayMonthsOrder({
				fromFieldName: FIELDS.policyHolderAnnualBirthDateFrom,
				toFieldName: FIELDS.policyHolderAnnualBirthDateTo,
			}),
		],
	},
	[FIELDS.birthYearFrom]: {
		deepPath: [FIELDS.birthYearFrom],
		dependentFields: [FIELDS.birthYearTo],
		validations: [
			isYearOrder({
				fromFieldName: FIELDS.birthYearFrom,
				toFieldName: FIELDS.birthYearTo,
			}),
		],
	},
	[FIELDS.birthYearTo]: {
		deepPath: [FIELDS.birthYearTo],
		dependentFields: [FIELDS.birthYearFrom],
		validations: [
			isYearOrder({
				fromFieldName: FIELDS.birthYearFrom,
				toFieldName: FIELDS.birthYearTo,
			}),
		],
	},
	[FIELDS.policyNumber]: {
		deepPath: [FIELDS.policyNumber],
		validations: [isNumber({ customMessage: getLabelMessage('validation:allowedCharacters') }), isPolicyNo()],
	},
	[FIELDS.rsNumber]: {
		deepPath: [FIELDS.rsNumber],
		validations: [isPolicyFrameworkNo()],
	},
	[FIELDS.policyStatus]: {
		deepPath: [FIELDS.policyStatus],
		validations: [],
	},
	[FIELDS.productDomain]: {
		deepPath: [FIELDS.productDomain],
		validations: [],
	},
	[FIELDS.product]: {
		deepPath: [FIELDS.product],
		validations: [],
	},
	[FIELDS.policyPaymentStatus]: {
		deepPath: [FIELDS.policyPaymentStatus],
		validations: [],
	},
	[FIELDS.policyHolderNumber]: {
		deepPath: [FIELDS.policyHolderNumber],
		validations: [],
	},
	[FIELDS.sellerLogin]: {
		deepPath: [FIELDS.sellerLogin],
		validations: [],
	},
	[FIELDS.product]: {
		deepPath: [FIELDS.product],
		validations: [],
	},
	[FIELDS.gcpContractsOnly]: {
		deepPath: [FIELDS.gcpContractsOnly],
		validations: [],
	},
	[FIELDS.gpContractsOnly]: {
		deepPath: [FIELDS.gpContractsOnly],
		validations: [],
	},
	[FIELDS.frameworkPolicyOnly]: {
		deepPath: [FIELDS.frameworkPolicyOnly],
		validations: [],
	},
	[FIELDS.activePolicyWoQuotationOnly]: {
		deepPath: [FIELDS.activePolicyWoQuotationOnly],
		validations: [],
	},
	[FIELDS.withSubordinates]: {
		deepPath: [FIELDS.withSubordinates],
		validations: [],
	},
	[FIELDS.carRegNo]: {
		deepPath: [FIELDS.carRegNo],
		validations: [isCarRegNo()],
	},
	[FIELDS.policyValueDateFrom]: {
		deepPath: [FIELDS.policyValueDateFrom],
		dependentFields: [FIELDS.policyValueDateTo],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.policyValueDateFrom, toFieldName: FIELDS.policyValueDateTo }),
		],
	},
	[FIELDS.policyValueDateTo]: {
		deepPath: [FIELDS.policyValueDateTo],
		dependentFields: [FIELDS.policyValueDateFrom],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.policyValueDateFrom, toFieldName: FIELDS.policyValueDateTo }),
		],
	},
	[FIELDS.policyOpenDateFrom]: {
		deepPath: [FIELDS.policyOpenDateFrom],
		dependentFields: [FIELDS.policyOpenDateTo],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.policyOpenDateFrom, toFieldName: FIELDS.policyOpenDateTo }),
		],
	},
	[FIELDS.policyOpenDateTo]: {
		deepPath: [FIELDS.policyOpenDateTo],
		dependentFields: [FIELDS.policyOpenDateFrom],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.policyOpenDateFrom, toFieldName: FIELDS.policyOpenDateTo }),
		],
	},
	[FIELDS.policyFinalDateFrom]: {
		deepPath: [FIELDS.policyFinalDateFrom],
		dependentFields: [FIELDS.policyFinalDateTo],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.policyFinalDateFrom, toFieldName: FIELDS.policyFinalDateTo }),
		],
	},
	[FIELDS.policyFinalDateTo]: {
		deepPath: [FIELDS.policyFinalDateTo],
		dependentFields: [FIELDS.policyFinalDateFrom],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.policyFinalDateFrom, toFieldName: FIELDS.policyFinalDateTo }),
		],
	},
	[FIELDS.policyValueDateAnnualFrom]: {
		deepPath: [FIELDS.policyValueDateAnnualFrom],
		dependentFields: [FIELDS.policyValueDateAnnualTo],
		validations: [
			isAnnualDayMonthsOrder({
				fromFieldName: FIELDS.policyValueDateAnnualFrom,
				toFieldName: FIELDS.policyValueDateAnnualTo,
			}),
		],
	},
	[FIELDS.policyValueDateAnnualTo]: {
		deepPath: [FIELDS.policyValueDateAnnualTo],
		dependentFields: [FIELDS.policyValueDateAnnualFrom],
		validations: [
			isAnnualDayMonthsOrder({
				fromFieldName: FIELDS.policyValueDateAnnualFrom,
				toFieldName: FIELDS.policyValueDateAnnualTo,
			}),
		],
	},
	[FIELDS.policyOpenDateAnnualFrom]: {
		deepPath: [FIELDS.policyOpenDateAnnualFrom],
		dependentFields: [FIELDS.policyOpenDateAnnualTo],
		validations: [
			isAnnualDayMonthsOrder({
				fromFieldName: FIELDS.policyOpenDateAnnualFrom,
				toFieldName: FIELDS.policyOpenDateAnnualTo,
			}),
		],
	},
	[FIELDS.policyOpenDateAnnualTo]: {
		deepPath: [FIELDS.policyOpenDateAnnualTo],
		dependentFields: [FIELDS.policyOpenDateAnnualFrom],
		validations: [
			isAnnualDayMonthsOrder({
				fromFieldName: FIELDS.policyOpenDateAnnualFrom,
				toFieldName: FIELDS.policyOpenDateAnnualTo,
			}),
		],
	},
});
